module.exports = __webpack_public_path__ + "static/media/Indicator.8910efde.svg";